import React from "react";
import { Navigate } from "react-router-dom";

//Authentication
import LogInPage from "../pages/Authentication/Login.js";

//Route Config
import ForgetPassword from "pages/Authentication/ForgetPassword.js";
import ResetPassword from "pages/Authentication/ResetPassword.js";
// import Courier from "pages/Courier/index.js";
import User from "pages/User/index.js";
import Order from "pages/Order/index.js";
import OrderDetails from "pages/Order/details.js";
import NotificationLogs from "pages/NotificationLogs/index.js";
import Layout from "pages/Test/components/Layout.js";

const authProtectedRoutes = [
  // ...TestConfig,
  // ...UserConfig
  // {
  //   path: "/courier",
  //   exact: true,
  //   component: <Courier/>
  // }
];

// this route should be at the end of all other routes
authProtectedRoutes.push(
  {
    path: "/dashboard",
    exact: true,
    component: <Layout/>
  },
  // {
  //   path: "/courier",
  //   exact: true,
  //   component: <Courier/>
  // },
  {
    path: "/users",
    exact: true,
    component: <User/>
  },
  {
    path: "/orders",
    exact: true,
    component: <Order/>
  },
  {
    path: "/order/:id",
    exact: true,
    component: <OrderDetails/>
  },
  {
    path: "/notification-logs",
    exact: true,
    component: <NotificationLogs/>
  },
  { path: "*", component: <Navigate to="/dashboard" /> }
);

const publicRoutes = [
  // Authentication Page
  { path: "/login", component: <LogInPage /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/reset-password", component: <ResetPassword /> }
];

export { authProtectedRoutes, publicRoutes };
